<label class="form-label">{{ label }}</label>
<div class="input-group">
  <input type="text" class="form-control" [(ngModel)]="text" [ngModelOptions]="{standalone: true}" (keydown)="onKeyDown($event)">
  <span class="input-group-text"><i role="button" class="bi bi-plus-circle" (click)="add()"></i></span>
</div>
<div>
  @for (value of values; track value) {
    <span class="badge rounded-pill bg-primary me-1">
      {{ value }}
      <i role="button" class="bi bi-x ms-2" (click)="remove(value)"></i>
    </span>
  }
</div>
